var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 251 252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        opacity: .4;\n      }\n\n      .st0, .st1, .st2, .st3, .st4, .st5, .st6, .st7, .st8, .st9 {\n        isolation: isolate;\n      }\n\n      .st0, .st2, .st4, .st5, .st6, .st7, .st8, .st9 {\n        fill: #0a0a0b;\n      }\n\n      .st1 {\n        opacity: .7;\n      }\n\n      .st1, .st10 {\n        fill: #fbfcd4;\n      }\n\n      .st2 {\n        opacity: .2;\n      }\n\n      .st11 {\n        fill: #fff;\n      }\n\n      .st12 {\n        fill: none;\n      }\n\n      .st13 {\n        fill: #e0e0e0;\n      }\n\n      .st3 {\n        fill: #ffa900;\n        opacity: .6;\n      }\n\n      .st4 {\n        opacity: .1;\n      }\n\n      .st5 {\n        opacity: .2;\n      }\n\n      .st14 {\n        fill: #455a64;\n      }\n\n      .st6 {\n        opacity: .5;\n      }\n\n      .st7 {\n        opacity: .4;\n      }\n\n      .st8 {\n        opacity: .3;\n      }\n\n      .st9 {\n        opacity: .4;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    width: 251,
    height: 252
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M222.3,202.9l-85.1,49.1-95.8-55.4,85.1-49.1,95.8,55.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M222.3,202.9l-85.1,49.1-95.8-55.4,85.1-49.1,95.8,55.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M126.5,80.9v66.6l-85.1,49.1v-66.6l85.1-49.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M126.5,80.9v66.6l-85.1,49.1v-66.6l85.1-49.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M137.3,185.4v66.6l-95.8-55.4v-66.6l95.8,55.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M137.3,185.4v66.6l-95.8-55.4v-66.6l95.8,55.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M222.3,136.3v66.6l-95.8-55.4v-66.6l95.8,55.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M222.3,136.3v66.6l-95.8-55.4v-66.6l95.8,55.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M222.3,202.9v-66.6l-85.1,49.1v66.6l85.1-49.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M222.3,202.9v-66.6l-85.1,49.1v66.6l85.1-49.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M126.5,80.9v-36.9c.1,0,95.7,55.5,95.7,55.5v36.8c.1,0-95.7-55.4-95.7-55.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M126.5,80.9v-36.9c.1,0,95.7,55.5,95.7,55.5v36.8c.1,0-95.7-55.4-95.7-55.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M137.3,185.4l8-32.2,84.3-48.7-7.2,31.8-85.1,49.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M137.3,185.4l8-32.2,84.3-48.7-7.2,31.8-85.1,49.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M41.5,130l-10.2-33.4,85.1-49.1,10.1,33.4-85.1,49.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M41.5,130l-10.2-33.4,85.1-49.1,10.1,33.4-85.1,49.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M41.5,130l-20-27.6,95.8,55.4,20,27.6-95.8-55.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.5,130l-20-27.6,95.8,55.4,20,27.6-95.8-55.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M162.3,232.2c-.1,0-.3,0-.4-.2,0,0-.2-.2-.2-.4v-11.7c0-.1,0-.3.2-.4,0,0,.2-.2.4-.2.1,0,.3,0,.4.2,0,0,.2.2.2.4v11.7c0,.1,0,.3-.2.4,0,0-.2.2-.4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M160.8,224c0,0-.1,0-.2,0-.1,0-.2-.2-.3-.3s0-.3,0-.4l1.9-4.3,2.1,2.4c0,.1.1.2,0,.4,0,.1,0,.3-.2.3,0,0-.2.1-.4.1-.1,0-.3,0-.4-.1l-1-1.2-1.2,2.8c0,0-.1.2-.2.2,0,0-.2,0-.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M167.1,229.4c-.1,0-.3,0-.4-.2,0,0-.2-.2-.2-.4v-11.7c0-.1,0-.3.2-.4,0,0,.2-.2.4-.2s.3,0,.4.2c0,0,.1.2.1.4v11.7c0,0,0,.1,0,.2,0,0,0,.1-.1.2s-.1,0-.2.1c0,0-.1,0-.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M165.6,221.3c0,0-.1,0-.2,0,0,0-.1,0-.2-.1s0-.1-.1-.2,0-.1,0-.2,0-.1,0-.2l1.9-4.4,2.1,2.4c0,0,.1.2.1.4s0,.3-.1.4c0,0-.1,0-.2.1,0,0-.1,0-.2,0s-.1,0-.2,0c0,0-.1,0-.2-.1l-1-1.2-1.2,2.8c0,.1-.1.2-.2.3-.1,0-.2,0-.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M148.4,240.1c-.2,0-.4,0-.6-.1-.2-.1-.4-.3-.5-.5-.1-.2-.2-.5-.1-.7v-1.4c0-.1,0-.3.2-.4,0,0,.2-.2.4-.2s.3,0,.4.2c0,0,.2.2.2.4v1.4c0,.2,0,.3.1.3s.2,0,.3,0c.3-.3.6-.7.7-1.1.2-.4.2-.8.2-1.3v-6c0-.1,0-.3.1-.4,0,0,.2-.2.4-.2s.3,0,.4.2c0,0,.2.2.2.4v6c0,.6,0,1.2-.4,1.8-.3.6-.6,1.1-1.1,1.5-.2.2-.5.2-.8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M142.9,235.3v-.9c.1-2.3.8-4.6,2-6.6s2.8-3.7,4.7-5c1.9-1.1,3.7-1.2,5.1-.4.7.5,1.3,1.2,1.7,2,.4.8.5,1.7.4,2.6v.3l-13.9,8ZM152.7,222.9c-.9,0-1.8.3-2.6.8-1.7,1.1-3.1,2.5-4.1,4.2-1.1,1.7-1.7,3.6-2,5.5l11.7-6.8c0-.7,0-1.3-.4-1.9-.3-.6-.7-1.1-1.3-1.5-.4-.2-.9-.3-1.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.5,102.4l95.8,55.4,20,27.6-21.1-26.7L21.5,102.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.3,136.3l-85.1,49.1v66.6l1.6-65.2,83.5-50.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M97.5,109.7c8.8-1.3,16.8-6.9,21.9-14,2.4-3.3,4.2-7,5.2-11,1.1-3.7,1.3-7.6.5-11.4-1.6-6.3-7.4-10.1-13.6-10.9-3.1-.4-6.3,0-9.3.9-3.1,1.1-5.8,3.1-7.7,5.8-1.2,1.4-1.9,3.2-2.2,5,0,.7.2,1.4.7,2s1.1.9,1.9,1c1.9.2,3.7-.3,5.3-1.3,1.9-1.1,3.6-2.5,4.9-4.2,2.9-3.6,5.1-7.7,6.4-12.1.9-3.8.9-7.7,0-11.5-.7-4-2.5-7.6-5.2-10.6-3.1-2.8-7-4.6-11.2-4.9-4.2-.6-8.4-.2-12.4,1.2-1.8.5-3.4,1.4-4.8,2.6-1,.9-2.1,2.4-1.7,3.9.4,1.5,2.6,2.2,4.1,2,2.2-.4,4.2-1.5,5.8-3.1,1.7-1.7,3.2-3.6,4.3-5.8.9-1.5,1.3-3.2,1.3-5-.1-7.3-8.2-12-14.6-13.4-1.7-.4-3.5-.5-5.2-.4-.6,0-.2,1,.2.9,3.4-.2,6.8.6,9.8,2.2,3,1.4,5.5,3.6,7.2,6.4.8,1.4,1.1,2.9,1.1,4.5,0,1.6-.5,3.1-1.4,4.4-1.1,2-2.5,3.8-4.2,5.3-1.4,1.2-3.5,2.7-5.4,2.5-.3,0-.6,0-.9-.3-.3-.2-.5-.4-.6-.7,0-.4,0-.8,0-1.1.1-.4.3-.7.6-1,1-1.1,2.3-1.9,3.7-2.5,3.5-1.4,7.2-2.1,10.9-1.8,3.9,0,7.6,1.3,10.8,3.5,2.8,2.3,4.7,5.4,5.6,8.9,1.1,3.5,1.5,7.3,1,11-.7,3.7-2.1,7.2-4.2,10.4-2.1,3.5-4.8,6.9-8.8,8.3-1,.4-3.1.9-3.5-.6-.4-1.4.7-3.2,1.5-4.3,1.6-2.5,3.9-4.5,6.7-5.7,2.7-1.1,5.5-1.5,8.4-1.3,5.4.4,10.9,3.2,12.8,8.6.9,3.2,1.1,6.6.3,9.9-.7,3.6-2,7-3.8,10.2-4,6.7-10,11.9-17.2,15-1.7.7-3.5,1.4-5.2,1.9-.2,0,0,.5.1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M60.8,9.6c-4.6-.3-11,3.3-8.7,6,2.3,2.7,8.3-1.6,8.3-1.6,0,0-.6,5.4,1.4,6,2,.6,4.6-4.5,2.7-7.8.9.4,2,.5,3,.4,1-.1,2-.5,2.8-1.1,2.8-2.1-.2-4-4.1-3.6,0,0,2.8-9.2-2.9-7.5-2.8.9-3.9,4.2-2.4,9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.8,9.6c-4.6-.3-11,3.3-8.7,6,2.3,2.7,8.3-1.6,8.3-1.6,0,0-.6,5.4,1.4,6,2,.6,4.6-4.5,2.7-7.8.9.4,2,.5,3,.4,1-.1,2-.5,2.8-1.1,2.8-2.1-.2-4-4.1-3.6,0,0,2.8-9.2-2.9-7.5-2.8.9-3.9,4.2-2.4,9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M65.1,11.5c-.3-.2-.5-.5-.8-.7-.4-.3-.8-.6-1.2-.9-.4-.3-.8-.5-1.2-.8-.2-.1-.5-.3-.8-.4-.4-.2-.8-.2-1.2-.2-.1,0-.2,0-.3,0,0,0-.2.1-.2.2,0,0,0,.2,0,.3,0,0,0,.2,0,.3.3.3.7.6,1.2.8l.6.3c.4.3.8.5,1.2.8.3.3.8.6,1.2.8.6.5,1.3.9,2,1.2,0,0,0,0,.1,0s0,0,.1,0c.6-.5-.3-1.6-.6-1.9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.83a6184e43d219508b4a30651a1a467a.svg";
export { ForwardRef as ReactComponent };